import { ConnectAlternative } from '../../../screens/manage/connect/connect-alternative';
import { youtubeConnectMessages as messages } from './youtube-connect-messages';

/** YouTube connect alternatives: basic (recommended) and advanced (playlists + delete). */
export const youtubeConnectAlternatives: ConnectAlternative[] = [
  {
    id: 'basic',
    name: messages.basicName,
    description: messages.basicDescription,
    permissions: messages.basicPermissions,
    action: { type: 'oauth' },
    icon: 'basic',
  },
  {
    id: 'advanced',
    name: messages.advancedName,
    description: messages.advancedDescription,
    permissions: messages.advancedPermissions,
    action: { type: 'oauth', loginSuffix: 'advanced' },
    icon: 'advanced',
  },
];
